export const GET_ALL_CUSTOMER_SUBSCRIBERS_REQ="GET_ALL_CUSTOMER_SUBSCRIBERS_REQ"
export const GET_ALL_CUSTOMER_SUBSCRIBERS_SUCC="GET_ALL_CUSTOMER_SUBSCRIBERS_SUCC"
export const GET_ALL_CUSTOMER_SUBSCRIBERS_FAIL="GET_ALL_CUSTOMER_SUBSCRIBERS_FAIL"

export const  CUSTOMERS_DATA_FILTER_DATES= "CUSTOMERS_DATA_FILTER_DATES"
export const  CUSTOMERS_DATA_FILTER_LOCATION= "CUSTOMERS_DATA_FILTER_LOCATION"